export default {"src":"/_next/static/media/tailwind.48de7862.svg","height":1499,"width":2500,"blurWidth":0,"blurHeight":0};